const SadIcon = () => {
    return (
        <svg
            width="90"
            height="90"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginBottom: "12px", opacity: 0.85 }}
        >
            <circle cx="60" cy="60" r="48" fill="#F1F3F5" />
            <circle cx="43" cy="50" r="5" fill="#6C757D" />
            <circle cx="77" cy="50" r="5" fill="#6C757D" />
            <path
                d="M42 78C48 68 72 68 78 78"
                stroke="#6C757D"
                strokeWidth="5"
                strokeLinecap="round"
            />
            <path
                d="M34 35C38 31 43 30 48 32"
                stroke="#ADB5BD"
                strokeWidth="4"
                strokeLinecap="round"
            />
            <path
                d="M72 32C77 30 82 31 86 35"
                stroke="#ADB5BD"
                strokeWidth="4"
                strokeLinecap="round"
            />
        </svg>
    )
}

export default SadIcon;